import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
// import './ApplyLeaveForm.css'; // Import your CSS styles

const ApplyLeaveForm = ({ leaveTypes, applyLeave, id, pageBack }) => {
    const [formData, setFormData] = useState({
        user_id: '',
        start_date: '',
        end_date: '',
        leave_type_id: '',
        reason: '',
        status: '',
    });

    const [operation, setOperation] = useState('Add');

    useEffect(() => {
        if (id) {
            setOperation('Edit');
            setFormData({
                user_id: applyLeave.user_id || '',
                start_date: applyLeave.start_date || '',
                end_date: applyLeave.end_date || '',
                leave_type_id: applyLeave.leave_type_id || '',
                reason: applyLeave.reason || '',
                status: applyLeave.status || '',
            });
        } else {
            const today = new Date();
            const tomorrow = new Date(today);
            tomorrow.setDate(today.getDate() + 1);
            setFormData({
                user_id: '',
                start_date: today.toISOString().split('T')[0],
                end_date: tomorrow.toISOString().split('T')[0],
                leave_type_id: '',
                reason: '',
                status: '',
            });
        }
    }, [id, applyLeave]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Perform save action here
        console.log(formData);
        // You can use an API call to save the data
        Swal.fire('Success', 'Leave applied successfully!', 'success').then(() => {
            window.location.href = pageBack; // Redirect after submission
        });
    };

    return (
        <div id="page-container" className="page-header-fixed page-sidebar-fixed fade in">
            <div id="content" className="">
                <div className="panel panel-default with-rounded-corner with-shadow">
                    <form onSubmit={handleSubmit} className="stdform">
                        <input type="hidden" name="id" value={id} />
                        <div className="panel-heading border-0">
                            <span className="panel-title">{operation} Apply Leave</span>
                        </div>
                        <div className="panel-body">
                            <div className="row">
                                <div className="col-4">
                                    <label>Leave Start Date</label>
                                    <input
                                        type="date"
                                        name="start_date"
                                        value={formData.start_date}
                                        onChange={handleChange}
                                        min={formData.start_date}
                                        required
                                    />
                                </div>
                                <div className="col-4">
                                    <label>Leave End Date</label>
                                    <input
                                        type="date"
                                        name="end_date"
                                        value={formData.end_date}
                                        onChange={handleChange}
                                        min={formData.start_date}
                                        required
                                    />
                                </div>
                                <div className="col-4">
                                    <label>Leave Type</label>
                                    <select
                                        name="leave_type_id"
                                        value={formData.leave_type_id}
                                        onChange={handleChange}
                                        required
                                    >
                                        <option value="">Select Leave Type</option>
                                        {leaveTypes.map((type) => (
                                            <option key={type.id} value={type.id}>
                                                {type.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-12">
                                    <label>Reason</label>
                                    <textarea
                                        name="reason"
                                        value={formData.reason}
                                        onChange={handleChange}
                                        placeholder="Enter Reason"
                                        required
                                    />
                                </div>
                            </div>
                            <div className="clearfix"></div>
                            <button type="button" className="btn btn-default" onClick={() => window.location.href = pageBack}>
                                Back
                            </button>
                            <button type="submit" className="btn btn-primary">
                                {operation} Leave
                            </button>
                        </div>
                    </form>
                </div>
                <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
                    <i className="ti-arrow-up"></i>
                </a>
            </div>
        </div>
    );
};

export default ApplyLeaveForm;